import { useQuery, useQueryClient } from '@tanstack/react-query';
import { type ProposalCreditAnalysisResolution, proposalApi } from '@/api/commercial/proposals';

export const proposalCreditAnalysisResolutionKey = (proposalId?: string) =>
  ['proposal-credit-analysis-resolution', proposalId] as const;

export function useProposalCreditAnalysisResolution(proposalId?: string) {
  return useQuery({
    queryKey: proposalCreditAnalysisResolutionKey(proposalId),
    queryFn: () => proposalApi.resolveCreditAnalysis(proposalId!),
    enabled: Boolean(proposalId),
    staleTime: 0,
    refetchOnMount: 'always',
  });
}

export function useInvalidateProposalCreditAnalysis() {
  const queryClient = useQueryClient();

  return async (proposalId: string): Promise<void> => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ['proposal', proposalId] }),
      queryClient.invalidateQueries({
        queryKey: proposalCreditAnalysisResolutionKey(proposalId),
      }),
    ]);
  };
}

export type { ProposalCreditAnalysisResolution };
